import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { AlertTriangle } from "lucide-react";

interface MaintenanceConfig {
  enabled: boolean;
  message: string;
  allow_active_sessions: boolean;
  freeze_transactions: boolean;
}

export function MaintenanceBanner() {
  const [config, setConfig] = useState<MaintenanceConfig | null>(null);

  useEffect(() => {
    const fetchStatus = async () => {
      try {
        const { data, error } = await supabase
          .from("system_settings")
          .select("value")
          .eq("key", "maintenance_mode")
          .maybeSingle();

        if (!error && data?.value) {
          setConfig(data.value as unknown as MaintenanceConfig);
        }
      } catch {
        // Silently ignore - table may not exist yet
      }
    };

    fetchStatus();

    // Poll every 30 seconds
    const interval = setInterval(fetchStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  if (!config?.enabled) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] bg-destructive text-destructive-foreground px-4 py-2.5 text-center text-sm font-medium flex items-center justify-center gap-2">
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <span>{config.message}</span>
      {config.freeze_transactions && (
        <span className="text-xs opacity-80 ml-2">
          · Transactions paused
        </span>
      )}
    </div>
  );
}
